import styled from 'styled-components'
import colors from '@settings/styleSettings'
import Radio from '@mui/material/Radio'

export const RadioStyled = styled(Radio)`
  color: ${colors.primary} !important;
`

export const RadioArea = styled.div`
  border: 1px solid;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 16px 0px;
  width: 50%;
  height: 15px;
  border-color: ${({ selected }) => (selected ? colors.primary : colors.softGray)};
  font-family: Circular-Std;
  font-size: 14px;
  cursor: pointer;

  @media (max-width: 1025px) {
    width: 50%;
  }
  @media (max-width: 380px) {
    width: 100%;
  }

`
export const FieldsArea = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 8px;
  gap: 10px;

  @media (max-width: 380px) {
    width: 100%;
    flex-direction: column;
  }
`
export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`
